/**
 * FilterBarBody
 * 
 * @Author: Focci
 * @Date: 2023-07-21 14:44:50
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-21 14:44:50
 */

'use client'

import PropTypes from 'prop-types'
import SVGMenushort from '@img/menushort.svg'
import SubcribeTrigger from '@comp/page/search/common/subcribe/SubcribeTrigger'
import ShowMap from '@comp/page/search/common/ShowMap'
import useAdjustElements from '@hook/useAdjustElements'
import { useEffect, useMemo, useRef } from 'react'
import { useTranslations } from 'next-intl'
import FilterTrigger from './FilterTrigger'
import { getFilterCount, getFilterIcons } from './lib'

export default function FilterBarBody({
  categoryName = '',
  apiParam = {},
  searchParam = {},
  type,
  isMapListing,
  onClick = () => {},
  disabled
}) {
  const elRef = useRef()
  const ts = useTranslations('search')
  const tpr = useTranslations('productspec')
  const th = useTranslations('house')

  const { watchElement } = useAdjustElements()

  const count = useMemo(() => getFilterCount(searchParam), [searchParam])
  const iconOptions = getFilterIcons({ 
    tpr, th, apiParam, type, searchParam 
  })
  
  useEffect(() => watchElement(elRef.current, true), [watchElement])
  
  return (
    <div className="flex items-center gap-2 custom-scroll-bar" ref={elRef}>
      <FilterTrigger
        actived
        label={categoryName}
        showIcon={false}
        prevIcon={<SVGMenushort />}
        onClick={() => onClick()}
        disabled={disabled}
        activedClassName="bg-primary text-white border-0"
      />
      {iconOptions.map((option) => (
        <div data-adjust-el key={option.label}>
          <FilterTrigger 
            key={option.label} 
            label={option.label}
            actived={option.actived}
            disabled={disabled}
            onClick={() => onClick(option)}
          />
        </div>
      ))}
      <FilterTrigger
        actived={!!apiParam.filter}
        label={ts('moreConditions')}
        onClick={() => onClick()}
        disabled={disabled}
        count={count}
      />
      <SubcribeTrigger
        type={type}
        searchParam={searchParam}
      />
      {!isMapListing && (
        <div className="ml-auto hidden md:flex items-center">
          <ShowMap type={type} searchParam={searchParam} />
        </div>
      )}
    </div>
  )
}

FilterBarBody.propTypes = {
  categoryName: PropTypes.string,
  apiParam: PropTypes.object,
  type: PropTypes.string.isRequired,
  isMapListing: PropTypes.bool,
  onClick: PropTypes.func,
}
